export default __webpack_public_path__ + "static/media/kalenday.b45c7b54.png";